import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import at from 'lodash/at';
import Text from '@adsk/bim360-matrix-react-text';
import SimpleModal from '@adsk/bim360-matrix-react-simple-modal';
import PermissionIndicator from '@adsk/bim360-matrix-react-permission-indicator';
import {NewAdminPermissionsArray} from '../../../constants/issues-admin';

const noBasicOrderedArray = at(NewAdminPermissionsArray, [0, 2, 1, 3]);

const IssuesPermissionsDetailModal = props => (
  <SimpleModal
    container={props.container}
    className="IssuesPermissionsDetailModal"
    title={i18n.t('issuesAdmin.permissions.detailModalTitle')}
    show={props.show}
    onExited={() => props.onExited()}
  >
    <Text className="IssuesPermissionsDetailModal__general-description" hasHTML>
      {i18n.t('issuesAdmin.permissions.detailModalGeneralDescription')}
    </Text>
    <div
      className="IssuesPermissionsDetailModal__permissions-container"
      data-testid="IssuesPermissionsDetailModal__permissions-container"
    >
      {noBasicOrderedArray.map((permissionDetail, index) => (
        <div key={index} className="IssuesPermissionsDetailModal__permission-container">
          <div className="IssuesPermissionsDetailModal__permission-title">
            <span>{i18n.t(`issuesAdmin.permissions.permissionsType.${permissionDetail.label}`)}</span>
            <PermissionIndicator pillCount={3} value={permissionDetail.value} />
          </div>
          <span className="IssuesPermissionsDetailModal__permission-description">
            {i18n.t(`issuesAdmin.permissions.permissionsType.${permissionDetail.label}Description`)}
          </span>
        </div>
      ))}
    </div>
  </SimpleModal>
);

IssuesPermissionsDetailModal.propTypes = {
  onExited: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  container: PropTypes.object
};

IssuesPermissionsDetailModal.displayName = 'IssuesPermissionsDetailModal';

export default IssuesPermissionsDetailModal;
